import { inject, Injectable } from '@angular/core';
import { createStore, select, setProp, withProps } from '@ngneat/elf';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize, mapTo, tap } from 'rxjs/operators';

import {
  CmsPageResponse,
  FooterResponse,
} from '@digital-platform/rs-cms/domain';
import { CmsContentService } from '../cms-content/cms-content.service';

export interface CmsPage {
  path: string;
  content: CmsPageResponse;
}

export interface invalidMessage {
  invalid: boolean;
  errorMessage: string;
}

@Injectable({
  providedIn: 'root',
})
export class CmsFooterService {
  public footerContent$: Observable<FooterResponse>;
  public emailInput$: Subject<string>;
  public emailInputError$: Subject<invalidMessage>;
  public emailInputSuccess$: Subject<boolean>;
  private cmsContent = inject(CmsContentService);
  private activeRequests = new BehaviorSubject(0);

  constructor() {
    this.footerContent$ = this.store.pipe(select((state) => state.content));
    this.emailInput$ = new Subject();
    this.emailInputError$ = new Subject();
    this.emailInputSuccess$ = new Subject();
    this.fetch().subscribe();
  }

  private store = createStore(
    { name: 'cmsFooterContent' },
    withProps<{
      content: FooterResponse;
    }>({
      content: [],
    })
  );

  public fetch(): Observable<void> {
    this.activeRequests.next(this.activeRequests.value + 1);

    return this.cmsContent.getFooterContent().pipe(
      tap((content) => this.setFooterContent(content)),
      mapTo(void 0),
      finalize(() => this.activeRequests.next(this.activeRequests.value - 1))
    );
  }

  private setFooterContent(content: FooterResponse): void {
    this.store.update(setProp('content', content));
  }
}
